module.exports = __webpack_public_path__ + "static/media/summer-camps.bbb1ad38.jpeg";